import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpService } from 'src/app/core/shared/http.service';
import { environment } from 'src/environments/environment';
import { AlarmData } from './camera-alarm.service';

const apiAddress = environment.apiAddress;

@Injectable({
  providedIn: 'root'
})
export class CameraService {

  constructor(private httpService: HttpService, private http: HttpClient) { }

  public getCameraStream(rs: string): Observable<Blob> {
    // Für MJPEG-Streams sollten wir responseType: 'blob' oder 'stream' verwenden
    return this.httpService.getStream(`Camera/stream?rs=${rs}`);
  }


  // KORRIGIERT: Query-Parameter statt POST-Body
  public moveCamera(direction: string, rs: string): Observable<any> {
    return this.httpService.post<any>(`Camera/move?direction=${direction}&rs=${rs}`, {});
  }

  // KORRIGIERT: Query-Parameter statt POST-Body
  public zoomCamera(zoom: number, rs: string): Observable<any> {
    return this.httpService.post<any>(`Camera/zoom?zoom=${zoom}&rs=${rs}`, {});
  }

  public getRecordings(rs: string): Observable<any> {
    return this.httpService.get<any>(`Camera/recordings?rs=${rs}`);
  }

  public getRecording(rs: string, id: string): Observable<Blob> {
    return this.httpService.getBlob(`Camera/recording?rs=${rs}&id=${id}`);
  }

  // KORRIGIERT: Blob-Response für Image-Display
  public getSnapshot(rs: string): Observable<Blob> {
    return this.httpService.getBlob(`Camera/snapshot?rs=${rs}`);
  }

  public downloadRecording(rs: string, id: string): Observable<any> {
    return this.httpService.getBlob(`Camera/recording?rs=${rs}&id=${id}`);
  }

  public getRecordingWithMemStream(rs: string, id: string/* , useMemStream: boolean */): Observable<Blob> {
    return this.httpService.getBlob(`Camera/recording?rs=${rs}&id=${id}&useMemStream=false`);
  }

  public getRtspWsRecording(rs: string, token: string, id: string, start: string, stop: string): Observable<Blob> {
    return this.httpService.getBlob(`Camera/rtspws-recording?rs=${rs}&token=${token}&id=${id}&start=${start}&stop=${stop}`);
  }

  public getRtspWebSocketStream(
    rs: string,
    token: string
  ): WebSocket {
    const params = new URLSearchParams({
      rs,
      token
    });
    const wsUrl = `${apiAddress}Camera/rtspws-recording?${params.toString()}`;

    // Subprotocol 'binary' angeben laut Backend(HTTP-Header Sec-WebSocket-Protocol)
    const ws = new WebSocket(wsUrl, ['binary']);
    ws.binaryType = 'arraybuffer';

    return ws;
  }

  public saveCameraPosition(name: string, rs: string): Observable<any> {
    return this.httpService.post<any>(`Camera/save-position?name=${name}&rs=${rs}`, {});
  }

  public gotoCameraPosition(name: string, rs: string): Observable<any> {
    return this.httpService.post<any>(`Camera/goto-position?name=${name}&rs=${rs}`, {});
  }

  public setCameraHomePosition(rs: string): Observable<any> {
    return this.httpService.post<any>(`Camera/set-home?rs=${rs}`, {});
  }

  public getCameraPositions(rs: string): Observable<string[]> {
    return this.httpService.get<string[]>(`Camera/positions?rs=${rs}`);
  }

  public gotoCameraHomePosition(rs: string): Observable<any> {
    return this.httpService.post<any>(`Camera/goto-home?rs=${rs}`, {});
  }

  public deleteCameraPosition(name: string, rs: string): Observable<any> {
    return this.httpService.delete<any>(`Camera/delete-position?name=${name}&rs=${rs}`);
  }


  public sendAlarm(alarm: AlarmData): Observable<any> {
    return this.httpService.post<any>(`api/Alarm`, alarm);
  }

 /*  public getRecordingsByGroupSorted(groupid: number): Observable<any> {
    return this.httpService.get<any>(`Camera/recordings/bygroup?groupid=${groupid}`);
  } */

}